import React from "react";
import { ChevronDown } from "lucide-react";

export const SORT_OPTIONS = [
  { value: "featured", label: "Featured" },
  { value: "newest", label: "Newest" },
  { value: "price-asc", label: "Price: Low to High" },
  { value: "price-desc", label: "Price: High to Low" },
];

const SortDropdown = ({ value, onChange }) => (
  <div className="relative inline-flex items-center">
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Sort products"
      data-testid="sort-dropdown"
      className="appearance-none border border-ink bg-transparent py-2.5 pl-4 pr-10 font-mono text-xs uppercase tracking-wider focus:outline-none"
    >
      {SORT_OPTIONS.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
    <ChevronDown size={16} className="pointer-events-none absolute right-3" />
  </div>
);

export default SortDropdown;
